import { ActionTree } from 'vuex';
import { AdminState } from './types';
import { RootState } from '@/store/types';
import { SET_WHITELIST } from './mutationTypes';
import { WhitelistEntry } from '@/types';

export const actions: ActionTree<AdminState, RootState> = {
  // The server answers every mutation with the whole list, so there is no local
  // add/remove to keep in step with it.
  socket_whitelistUpdated({ commit }, payload: { entries: WhitelistEntry[] }) {
    commit(SET_WHITELIST, payload?.entries || []);
  },
};
